import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL: string = import.meta.env.VITE_TEST_FRESHERS_CHALLENGE_BASE_URL;

export const CategoryListApiSlice = createApi({
  reducerPath: "categoryListApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  tagTypes: ["getCategoryList"],
  endpoints: (builder) => ({
    getCategoryList: builder.query<
      any,
      { categoryId: string; pageNo: number; pageSize: number }
    >({
      query: ({ categoryId, pageNo, pageSize }) => ({
        url: `list/all?categoryId=${categoryId}&pageNo=${pageNo}&pageSize=${pageSize}`,
        method: "GET",
      }),
      providesTags: ["getCategoryList"],
    }),
    getListsForQuestion: builder.query<any, { challengeId: number }>({
      query: ({ challengeId }) => ({
        url: `challenge/list-count?challengeId=${challengeId}`,
        method: "GET",
      }),
    }),
    getUnassignedListsForQuestion: builder.query<
      any,
      { challengeId: number; categoryId: string }
    >({
      query: ({ challengeId, categoryId }) => ({
        url: `list/all-dropdown?challengeId=${challengeId}&categoryId=${categoryId}`,
        method: "GET",
      }),
    }),
    addListsForQuestion: builder.mutation<
      any,
      { challengeId: number; challengeListIds: string[] }
    >({
      query: ({ challengeId, challengeListIds }) => ({
        url: `challenge/assign-lists-challenge?challengeId=${challengeId}`,
        method: "PUT",
        body: challengeListIds,
      }),
    }),
    addCategoryList: builder.mutation<
      { httpStatus: string; statusCode: number },
      { payload: string; categoryId: string; logo?: File | null }
    >({
      query: ({ payload, categoryId }) => {
        const formData = new FormData();
        formData.append("listRequest", payload.toString());
        formData.append("categoryId", categoryId);
        // formData.append("logo", logo!);
        return {
          url: `list`,
          method: "POST",
          body: formData,
        };
      },
    }),
    getAllListDropDown: builder.query<any, { challengeCategoryId: string }>({
      query: ({ challengeCategoryId }) => ({
        url: `list/challenge-list-dropdown`,
        method: "GET",
        params: { challengeCategoryId },
      }),
    }),
    getCategoryListDropdown: builder.query<
      any,
      { challengeCategoryId: string }
    >({
      query: ({ challengeCategoryId }) => ({
        url: `list/challenge-list-dropdown?challengeCategoryId=${challengeCategoryId}`,
        method: "GET",
      }),
    }),
    getUnassignedQuestionsForList: builder.query<
      any,
      {
        challengeListId: string | number;
        categoryId: string;
      }
    >({
      query: ({ challengeListId, categoryId }) => ({
        url: `list/get-unmapped-challenges-by-list?challengeListId=${challengeListId}&categoryId=${categoryId}`,
        method: "GET",
      }),
    }),
    getAssignedQuestionsForList: builder.query<
      any,
      {
        challengeListId: string;
      }
    >({
      query: ({ challengeListId }) => ({
        url: `list/get-challenges-by-list?challengeListId=${challengeListId}`,
        method: "GET",
      }),
    }),
    getChallengesList: builder.query<
      any,
      {
        challengeListId: string;
        pageNo: number;
        pageSize: number;
        userId?: string;
      }
    >({
      query: ({ challengeListId, pageNo, pageSize, userId }) => {
        const params = new URLSearchParams({
          challengeListId,
          pageNo: String(pageNo),
          pageSize: String(pageSize),
        });

        if (userId) {
          params.append("userId", userId);
        }

        return {
          url: `list?${params.toString()}`,
          method: "GET",
        };
      },
    }),
    assignQuestionsForList: builder.mutation<
      any,
      {
        listId: string | number;
        challengeIds: (string | number)[];
      }
    >({
      query: ({ listId, challengeIds }) => ({
        url: `list/challenge-lists/${listId}`,
        method: "PUT",
        body: challengeIds,
      }),
    }),
  }),
});

export const {
  useGetCategoryListQuery,
  useLazyGetCategoryListQuery,
  useAddCategoryListMutation,
  useGetCategoryListDropdownQuery,
  useGetListsForQuestionQuery,
  useGetUnassignedListsForQuestionQuery,
  useAddListsForQuestionMutation,
  useGetAllListDropDownQuery,
  useLazyGetAllListDropDownQuery,
  useAssignQuestionsForListMutation,
  useGetAssignedQuestionsForListQuery,
  useGetUnassignedQuestionsForListQuery,
  useGetChallengesListQuery,
  useLazyGetChallengesListQuery,
} = CategoryListApiSlice;
